enum Flow {
  BEGIN,
  NAME,
  SPOT_COUNT,
  SHAPE,
}

export default Flow;
